export enum EProductVariantConnectionStatus {
  CREATED = 'created',
  NOT_CONNECTED = 'not_connected',
  CONNECTED = 'connected',
  IGNORED = 'ignored',
  DELETED = 'deleted',
}
